"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsHelper = void 0;
/**
 * Helper used to cache, get & push GA payloads. It also provides intellisense for payload tags in methods if T of string union is given
 */
var AnalyticsHelper = /** @class */ (function () {
    function AnalyticsHelper(eventName) {
        this.payloadCache = new Map();
        this.eventName = eventName;
    }
    /**
     * Get analytics payload by key. The date time and process start date time are updated here.
     * Caches generated of given key.
     * Key should be formatted as 'action.index.tag' eg. 'click.3.solardailyestimatedusagemodal'
     */
    AnalyticsHelper.prototype.get = function (key, processStartDateTime) {
        var payload = this.payloadCache.get(key);
        if (!payload) {
            payload = AnalyticsHelper.generatePayload(this.eventName, key);
            this.payloadCache.set(key, payload);
        }
        if (processStartDateTime) {
            payload.process.processStartDateTime = processStartDateTime;
        }
        else {
            delete payload.process.processStartDateTime;
        }
        payload.process.step.dateTime = Date.now();
        return payload;
    };
    /**
     * Push analytic payload of given key to GA.
     * Key should be formatted as 'action.index.tag' eg. 'click.3.solardailyestimatedusagemodal'
     */
    AnalyticsHelper.prototype.push = function (key, processStartDateTime) {
        var payload = this.get(key, processStartDateTime);
        AnalyticsHelper.push(payload);
    };
    /** Push analytics payload to GA */
    AnalyticsHelper.push = function (payload) {
        if (!window.dataLayer) {
            console.warn('no dataLayer found', payload);
            return;
        }
        window.dataLayer.push(payload);
    };
    /** Generate analytic payloads from payload lists */
    AnalyticsHelper.generatePayload = function (eventName, payloadTag) {
        var _a = eventName.split('.'), moduleNameCollection = _a.slice(1);
        var moduleName = moduleNameCollection.join('.');
        var _b = payloadTag.split('.'), actionType = _b[0], stepIndex = _b[1], nameCollection = _b.slice(2);
        var name = nameCollection.join('.');
        return {
            event: eventName,
            process: {
                step: {
                    index: stepIndex,
                    dateTime: Date.now(),
                },
                // 'ma.' is auto added by GA client
                // name might be empty
                name: "".concat(moduleName).concat(name ? ".".concat(name) : ''),
                // uppercase first char to adhere to type
                actionType: (actionType.charAt(0).toUpperCase() + actionType.slice(1)),
            },
        };
    };
    return AnalyticsHelper;
}());
exports.AnalyticsHelper = AnalyticsHelper;
//# sourceMappingURL=AnalyticsHelper.js.map